import { createContext } from "react";

const CatTipoPrecioContext = createContext();

export default CatTipoPrecioContext;
